export default __webpack_public_path__ + "static/image1-85506d91787171a1a6844be019dcb051.svg";